import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WmIconModule } from '../icon/index';
import { ButtonComponent } from './button.component';
import { WmSpinnerModule } from '../spinner/index';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [ButtonComponent],
	imports: [CommonModule, WmIconModule, WmSpinnerModule, RouterModule],
	exports: [ButtonComponent]
})
export class WmButtonModule {}
